/* eslint-disable react/destructuring-assignment */
import decode from 'jwt-decode';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import apiAuth from '../services/apiAuth';
import apiShipper from '../services/apiShipper';
import { AuthProvider } from './authContext';
import { logout as logoutService } from './authService';

class Auth extends Component {
  constructor(props) {
    super(props);
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      this.state = this.getSession(accessToken);
    } else {
      this.state = {
        authenticated: false,
        user: {},
        accessToken: '',
      };
    }
  }

  carregarConpass = () => {
    if (window.Conpass) {
      const profile =
        this.state.user.profile === 'CLIENTE'
          ? 'shipper-cliente'
          : 'shipper-adm';

      window.Conpass.init({
        name: localStorage.getItem('name'),
        email: localStorage.getItem('email'),
        custom_fields: {
          grupo: ['usuario_shipper', profile],
          plataforma: 'tmov_shipper',
        },
      });
    }
  };

  /**
   * @description Pega sessão do usuário logado através do token
   * @param {String} accessToken
   */
  getSession = accessToken => ({
    user: {
      ...decode(accessToken).user,
      cliente_tmov_id: parseInt(localStorage.getItem('cliente_tmov_id'), 10),
    },
    authenticated: true,
    accessToken,
  });

  /**
   * @description Faz login no back
   * @param {String} login
   * @param {String} senha
   */
  initiateLogin = async (login, senha) => {
    const responseLogin = await apiAuth.post('/token', {
      login,
      password: senha,
    });

    // seta token para requests posteriores
    localStorage.setItem('access_token', responseLogin.data.token);
    localStorage.setItem('refresh_token', responseLogin.data.refreshToken);

    // TODO a api de auth deve buscar os clientes para compor o usuário
    // e deixar a informação dentro do token
    // Pega cliente principal
    const responseCliente = await apiShipper.get(
      `/clientes/${responseLogin.data.user.cliente_id}`
    );

    const cliTmov = await apiShipper.get(
      `/clientes/tmov/raiz/full-search?descricao=${responseCliente.data.cnpj_resumido}`
    );

    // Pega clientes secundários
    let responseClienteSecundarios = null;
    if (responseLogin.data.user.cliente_id_secundarios) {
      responseClienteSecundarios = await apiShipper.get('/clientes', {
        params: {
          idClienteSecundarios: responseLogin.data.user.cliente_id_secundarios,
        },
      });
    }

    this.handleAuthentication(
      responseLogin.data,
      responseCliente.data,
      responseClienteSecundarios?.data,
      cliTmov.data[0].id
    );

    if (localStorage.getItem('name')) {
      this.carregarConpass();
    }
  };

  /**
   * @description Desloga do sistema
   * @param {Navigation} history
   */
  logout = (history = null) => {
    this.setState({
      authenticated: false,
      user: {},
      accessToken: '',
    });
    logoutService(history);
  };

  /**
   * @description Decodifica token
   * @param {Object} userData
   * @param {Object} clientData
   * @param {Object} secondaryClientData
   * @param {number} cliente_tmov_id
   */
  handleAuthentication = (
    userData,
    clientData,
    secondaryClientData,
    cliente_tmov_id
  ) => {
    const decoded = decode(userData.token);
    this.setSession(
      userData.token,
      decoded.user,
      clientData,
      secondaryClientData,
      cliente_tmov_id
    );
  };

  /**
   * @description Cria sessão do usuário na aplicação
   * @param {String} token
   * @param {Object} user
   * @param {Object} clientData
   * @param {Object} secondaryClientData
   * @param {number} cliente_tmov_id
   */
  setSession(token, user, clientData, secondaryClientData, cliente_tmov_id) {
    localStorage.setItem('idUsuario', user.id);
    localStorage.setItem('name', user.name);
    localStorage.setItem('nameUsuarioAlternado', user.nameUsuarioAlternado);
    localStorage.setItem('idUsuarioAlternado', user.idUsuarioAlternado);
    localStorage.setItem('email', user.email);
    localStorage.setItem('cliente_id', user.cliente_id);
    localStorage.setItem('cliente_cnpj_resumido', clientData?.cnpj_resumido);
    localStorage.setItem('cliente_razao_social', clientData?.razao_social);
    localStorage.setItem('cliente_tmov_id', cliente_tmov_id);
    localStorage.setItem('profile', user.profile);
    if (secondaryClientData) {
      localStorage.setItem(
        'cliente_secundarios',
        JSON.stringify(secondaryClientData.content)
      );
    }

    user.cliente_tmov_id = cliente_tmov_id;
    user.id_usuario_integracao = 5921;

    this.setState({
      authenticated: true,
      accessToken: token,
      user,
    });
  }

  /**
   * @description Cria componente auth
   */
  render() {
    const authProviderValue = {
      ...this.state,
      initiateLogin: this.initiateLogin,
      handleAuthentication: this.handleAuthentication,
      logout: this.logout,
    };
    return (
      <AuthProvider value={authProviderValue}>
        {this.props.children}
      </AuthProvider>
    );
  }
}

Auth.propTypes = {
  children: PropTypes.instanceOf(Object),
};

Auth.defaultProps = {
  children: {},
};

export default Auth;
